import { GET_ALL_CLEARING_EVENTS,
    GET_ALL_CLEARING_EVENTS_SUCCESS,
    GET_ALL_CLEARING_EVENTS_FAIL,
    GET_ALL_CLEARING_ITEMS,
    GET_ALL_CLEARING_ITEMS_SUCCESS,
    GET_ALL_CLEARING_ITEMS_FAIL, 
    CHANGE_BATCH_SEND_NO,
    TEXT_FUNCTION_OPEN,
    VERIFY_PARCEL_EXISTENCE,
    VERIFY_PARCEL_EXISTENCE_SUCCESS,
    VERIFY_PARCEL_EXISTENCE_FAIL,
    CREATE_CLEARING_EVENT,
    CREATE_CLEARING_EVENT_SUCCESS,
    CREATE_CLEARING_EVENT_FAIL,
    DELETE_CLEARING_EVENT,
    DELETE_CLEARING_EVENT_SUCCESS,
    DELETE_CLEARING_EVENT_FAIL,
    RETRIED_PLUS_ONE,
    RETRIED_PLUS_ONE_SUCCESS,
    RETRIED_PLUS_ONE_FAIL,
    BATCH_SEND_EXPIRED_ALERT,
    BATCH_SEND_EXPIRED_ALERT_SUCCESS,
    BATCH_SEND_EXPIRED_ALERT_FAIL,
    GET_SMS_ALERT_HISTORY,
    GET_SMS_ALERT_HISTORY_SUCCESS,
    GET_SMS_ALERT_HISTORY_FAIL,
    TEST_BATCH_SEND_EXPIRED_ALERT,
    TEST_BATCH_SEND_EXPIRED_ALERT_SUCCESS,
    TEST_BATCH_SEND_EXPIRED_ALERT_FAIL,
    ABANDON_EXPIRED_PARCEL,
    ABANDON_EXPIRED_PARCEL_SUCCESS,
    ABANDON_EXPIRED_PARCEL_FAIL } from '../actions/types';

const initialState = {
    clearingEvents: [],
    clearingEventsLoading: false,
    clearingEventsError: false,
    clearingItems: [],
    clearingItemsLoading: false,
    clearingItemsError: false,
    batchSendNo: '',
    textFunctionOpen: false,
    parcelExistenceLoading: false,
    parcelExistence: [],
    parcelExistenceError: false,
    createClearingEventLoading: false,
    createClearingEvent: [],
    createClearingEventError: false,
    retriedPlusOneLoading: false,
    retriedPlusOneEvent: [],
    retriedPlusOneEventError: false,
    batchSendExpiredAlertLoading: false,
    batchSendExpiredAlert: [],
    batchSendExpiredAlertError: false,
    getSmsAlertHistoryLoading: false,
    getSmsAlertHistory: [],
    getSmsAlertHistoryError: false,
    testBatchSendExpiredAlertLoading: false,
    testBatchSendExpiredAlert: [],
    testBatchSendExpiredAlertError: false,
    abandonExpiredParcel: [],
    abandonExpiredParcelLoading: false,
    abandonExpiredParcelError: false
}

export default function smReducer(state = initialState, action){
    switch(action.type){
        case GET_ALL_CLEARING_EVENTS:
            return {
                ...state,
                clearingEventsLoading: true,
                no: action.payload
            }
        case GET_ALL_CLEARING_EVENTS_SUCCESS:
            return {
                ...state,
                clearingEvents: action.payload,
                clearingEventsLoading: false
            }
        case GET_ALL_CLEARING_EVENTS_FAIL:
            return {
                ...state,
                clearingEventsLoading: false,
                clearingEventsError: action.payload
            }
        case GET_ALL_CLEARING_ITEMS:
            return {
                ...state,
                clearingItemsLoading: true
            }
        case GET_ALL_CLEARING_ITEMS_SUCCESS:
            return {
                ...state,
                clearingItems: action.payload,
                clearingItemsLoading: false
            }
        case GET_ALL_CLEARING_ITEMS_FAIL:
            return {
                ...state,
                clearingItemsLoading: false,
                clearingItemsError: action.payload
            }
        case CHANGE_BATCH_SEND_NO:
            return {
                ...state,
                batchSendNo: action.payload
            }
        case TEXT_FUNCTION_OPEN:
            return {
                ...state,
                textFunctionOpen: action.payload
            }
        case VERIFY_PARCEL_EXISTENCE:
            return {
                ...state,
                parcelExistenceLoading: true
            }
        case VERIFY_PARCEL_EXISTENCE_SUCCESS:
            return {
                ...state,
                parcelExistenceLoading: false,
                parcelExistence: action.payload
            }
        case VERIFY_PARCEL_EXISTENCE_FAIL:
            return {
                ...state,
                parcelExistenceLoading: false,
                parcelExistenceError: action.payload
            }
        case CREATE_CLEARING_EVENT:
            return {
                ...state,
                createClearingEventLoading: true
            }
        case CREATE_CLEARING_EVENT_SUCCESS:
            return {
                ...state,
                createClearingEventLoading: false,
                createClearingEvent: action.payload
            }
        case CREATE_CLEARING_EVENT_FAIL:
            return {
                ...state,
                createClearingEventLoading: false,
                createClearingEventError: action.payload
            }
        case DELETE_CLEARING_EVENT:
            return {
                ...state,
                deleteClearingEventLoading: true
            }
        case DELETE_CLEARING_EVENT_SUCCESS:
            return {
                ...state,
                deleteClearingEventLoading: false,
                deleteClearingEvent: action.payload
            }
        case DELETE_CLEARING_EVENT_FAIL:
            return {
                ...state,
                deleteClearingEventLoading: false,
                deleteClearingEventError: action.payload
            }
        case RETRIED_PLUS_ONE:
            return {
                ...state,
                retriedPlusOneLoading: true
            }
        case RETRIED_PLUS_ONE_SUCCESS:
            return {
                ...state,
                retriedPlusOneLoading: false,
                retriedPlusOne: action.payload
            }
        case RETRIED_PLUS_ONE_FAIL:
            return {
                ...state,
                retriedPlusOneLoading: false,
                retriedPlusOneError: action.payload
            }
        case BATCH_SEND_EXPIRED_ALERT:
            return {
                ...state,
                batchSendExpiredAlertLoading: true
            }
        case BATCH_SEND_EXPIRED_ALERT_SUCCESS:
            return {
                ...state,
                batchSendExpiredAlertLoading: false,
                batchSendExpiredAlert: action.payload
            }
        case BATCH_SEND_EXPIRED_ALERT_FAIL:
            return {
                ...state,
                batchSendExpiredAlertLoading: false,
                batchSendExpiredAlertError: action.payload
            }
        case GET_SMS_ALERT_HISTORY:
            return {
                ...state,
                getSmsAlertHistoryLoading: true
            }
        case GET_SMS_ALERT_HISTORY_SUCCESS:
            return {
                ...state,
                getSmsAlertHistoryLoading: false,
                getSmsAlertHistory: action.payload
            }
        case GET_SMS_ALERT_HISTORY_FAIL:
            return {
                ...state,
                getSmsAlertHistoryLoading: false,
                getSmsAlertHistoryError: action.payload
            }
        case TEST_BATCH_SEND_EXPIRED_ALERT:
            return {
                ...state,
                testBatchSendExpiredAlertLoading: true
            }
        case TEST_BATCH_SEND_EXPIRED_ALERT_SUCCESS:
            return {
                ...state,
                testBatchSendExpiredAlertLoading: false,
                testBatchSendExpiredAlert: action.payload
            }
        case TEST_BATCH_SEND_EXPIRED_ALERT_FAIL:
            return {
                ...state,
                testBatchSendExpiredAlertLoading: false,
                testBatchSendExpiredAlertError: action.payload
            }
        case ABANDON_EXPIRED_PARCEL:
            return {
                ...state,
                abandonExpiredParcelLoading: true
            }
        case ABANDON_EXPIRED_PARCEL_SUCCESS:
            return {
                ...state,
                abandonExpiredParcelLoading: false,
                abandonExpiredParcel: action.payload
            }
        case ABANDON_EXPIRED_PARCEL_FAIL:
            return {
                ...state,
                abandonExpiredParcelLoading: false,
                abandonExpiredParcelError: action.payload
            }
        default:
            return state;
    }
}